import { render, staticRenderFns } from "./advantageMarketing.vue?vue&type=template&id=789fcc12&scoped=true"
import script from "./advantageMarketing.vue?vue&type=script&lang=js"
export * from "./advantageMarketing.vue?vue&type=script&lang=js"
import style0 from "./advantageMarketing.vue?vue&type=style&index=0&id=789fcc12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789fcc12",
  null
  
)

export default component.exports